





































































































































































import { ExpedienteInterface, IResponseElement, Pagination, ReporteFiltroModel, ReporteInterface } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import { mdiDotsVertical, mdiDownloadCircleOutline, mdiFilterVariantMinus } from '@mdi/js'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
import { base64StringToBlob } from 'blob-util'
import * as FileSaver from 'file-saver'
import ReporteDescargarCU from '../components/ReporteDescargarCU.vue'
import ReporteDescargarSunedu from '../components/ReporteDescargarSunedu.vue'
// Components
import ReporteFiltro from '../components/ReporteFiltro.vue'

export default defineComponent({
  components: {
    PaginationSelect,
    PaginationFooter,
    ReporteFiltro,
    ReporteDescargarCU,
    ReporteDescargarSunedu,
  },
  setup() {
    const isFilterPanelActive = ref(false)
    const mostrarDescargarCUModal = ref(false)
    const mostrarDescargarSuneduModal = ref(false)
    const filtro = ref(new ReporteFiltroModel())
    const pagination = ref(new Pagination())

    const { isLoading } = useAppConfig()

    onMounted(() => {
      obtenerReportes(filtro.value)
    })

    const obtenerReportes = async (filter: ReporteFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('reporte/obtenerReportes', params)

      if (ok) {
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<ReporteInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const descargarCUModalOnClose = (actualizar: boolean) => {
      mostrarDescargarCUModal.value = false
      if (actualizar) {
        obtenerReportes(filtro.value)
      }
    }

    const descargarSuneduModalOnClose = (actualizar: boolean) => {
      mostrarDescargarSuneduModal.value = false
      if (actualizar) {
        obtenerReportes(filtro.value)
      }
    }

    const descargarFut = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/descargarFut', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const descargarFichaCU = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/descargarFichaCU', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const descargarFichaLibro = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProceso/descargarFichaLibro', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const exportar = async () => {
      isLoading.value = true
      const params = { ...filtro.value, start: filtro.value.start - 1 }
      const { ok, response } = await store.dispatch('reporte/exportar', params)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    return {
      credentials: computed(() => store.getters['auth/credentials']),
      reportes: computed<ReporteInterface[]>(() => store.getters['reporte/reportes']),
      filtro,
      isFilterPanelActive,
      isLoading,
      obtenerReportes,
      pagination,
      mostrarDescargarCUModal,
      mostrarDescargarSuneduModal,
      descargarCUModalOnClose,
      descargarSuneduModalOnClose,
      descargarFut,
      descargarFichaCU,
      descargarFichaLibro,
      exportar,
      icons: {
        mdiFilterVariantMinus,
        mdiDownloadCircleOutline,
        mdiDotsVertical,
      },
    }
  },
})
